import { Field, FieldAttributes, FieldProps } from 'formik';
import { forwardRef, useMemo } from 'react';
import Textarea, { TextareaProps } from './Textarea';

interface FormikTextareaProps extends TextareaProps {
    fieldProps?: FieldAttributes<any>;
}

const FormikTextarea = forwardRef<HTMLTextAreaElement, FormikTextareaProps>((props, ref) => {
    const { name, id, fieldProps, invalid, ...rest } = props;

    const idOrName = useMemo(() => {
        return id || name;
    }, [id, name]);

    return (
        <Field name={name} {...fieldProps}>
            {({ field, meta }: FieldProps) => (
                <Textarea
                    {...rest}
                    {...field}
                    ref={ref}
                    id={idOrName}
                    name={name}
                    invalid={(meta.touched && Boolean(meta.error)) || invalid}
                />
            )}
        </Field>
    );
});

export default FormikTextarea;
